import { createContext } from "react";

export const contextDefault = {
  selectedOption: "",
  setOption: (_option: string) => {},
};

export const OptionsContext = createContext(contextDefault);
